/**
 * Client-only env: nur PUBLIC_* Variablen.
 * Für Web-App / Cloudflare Pages: Keine Backend-Secrets, keine skipValidation.
 * Fehlt eine PUBLIC_* Variable → Build schlägt sofort mit klarer Fehlermeldung fehl.
 */
// turbo cache test: @acme/env touch
import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

import { deploymentEnvSuperRefine } from "./_deployment-env-refinements.js";
import type { ClientSchemaKeys } from "./_schemas/client.js";
import { clientSchema } from "./_schemas/client.js";

/** Entspricht dem, was createEnv für runtimeEnvStrict erwartet (Keys aus clientSchema). */
type ClientRuntimeEnv = Record<ClientSchemaKeys, string | undefined>;

function getClientRuntimeEnv(): ClientRuntimeEnv {
  const keys = Object.keys(clientSchema) as ClientSchemaKeys[];
  const out = {} as ClientRuntimeEnv;
  for (const key of keys) {
    out[key] = process.env[key];
  }
  return out;
}

export const env = createEnv({
  client: clientSchema,
  server: {},
  clientPrefix: "PUBLIC_",
  emptyStringAsUndefined: true,
  runtimeEnvStrict: getClientRuntimeEnv(),
  skipValidation: false,
  createFinalSchema: (shape) =>
    z.object(shape).superRefine((data, ctx) =>
      deploymentEnvSuperRefine(data, ctx, {
        includeServerMailRules: false,
      })
    ),
});

export const getIsDeploymentEnvironment = (...environments: (typeof env)["PUBLIC_DEPLOYMENT_ENVIRONMENT"][]) =>
  environments.includes(env.PUBLIC_DEPLOYMENT_ENVIRONMENT);

export const isDevOrLocalhostEnv = getIsDeploymentEnvironment("localhost", "development");
export const isProduction = env.PUBLIC_DEPLOYMENT_ENVIRONMENT === "production";
export const isLocalhost = env.PUBLIC_DEPLOYMENT_ENVIRONMENT === "localhost";

export type Env = typeof env;
